import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rep-acct',
  templateUrl: './rep-acct.component.html',
  styleUrls: ['./rep-acct.component.css']
})
export class RepAcctComponent implements OnInit {

  public menu_item_id = '55';
  
  private dp = [];
  displayedColumns = ['log_date', 'debit_amount', 'credit_amount', 'balance', 'source', 'log', 
    'log_no', 'comment'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'from_date': new Date(), 'to_date': new Date(), 'rep_type': 'account', 'acct_number': '',
    'cost_center': '0', 'title': 'كشف الحساب'
  };

  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
    'table_list': [
      {
        'table_name': '`sub_acct`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
        'condition': " AND `main_acct_no` != '" + 
          this.applicationConstants.main_acct_config['customer'] + "' AND  `main_acct_no` != '" + 
          this.applicationConstants.main_acct_config['supplier'] + "' AND `is_leaf` = '1' AND `is_cc` = '1'"
      },
      {
        'table_name': '`customer`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
        'condition': " AND (`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "' OR `branch_id` = '0')"
      },
      {
          'table_name': '`supplier`', 'selected_no': 'acct_number',
          'field_list': ['acct_number', 'supplier_name', 'supplier_name_en', 'mobile'],
          'condition': " AND (`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "' OR `branch_id` = '0')"
      }
    ]
  };

  search_cc = {
    'placeholder': 'مركز التكلفة (الرئيسي - Main)', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`cost_center`', 'selected_no': 'cc_id',
      'field_list': ['cc_name', 'cc_name_en']
    }]
  };

  total_debit = '0';
  total_credit = '0';
  total_balance = 0;
  type = ''; title = '';
  
  from_date; to_date; acct_name; date; cost_cneter_name;
  From_Date_Msg; To_Date_Msg; 

  rep_list = [];

  Statement_Date; Acct_Name; Debit_Total; Credit_Total; Acct_Msg; Acct_Statements;
  Acct_Statement; Customers; Suppliers; Bank_Accts; Acct_Placeholder; From_Date;
  To_Date; Acct_No; CC_Msg; CC_Number; CC_Name;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<RepAcctComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Statement_Date').subscribe((res: string) => {
      this.Statement_Date = res;
    });

    translate.get('Acct_Name').subscribe((res: string) => {
      this.Acct_Name = res;
    });

    translate.get('Debit_Total').subscribe((res: string) => {
      this.Debit_Total = res;
    });

    translate.get('Credit_Total').subscribe((res: string) => {
      this.Credit_Total = res;
    });

    translate.get('Acct_Msg').subscribe((res: string) => {
      this.Acct_Msg = res;
    });

    translate.get('Acct_Statements').subscribe((res: string) => {
      this.Acct_Statements = res;
    });

    translate.get('Acct_Statement').subscribe((res: string) => {
      this.Acct_Statement = res;
    });
    this.model['title'] = this.Acct_Statement;

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Acct_No').subscribe((res: string) => {
      this.Acct_No = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });
    
    translate.get('CC_Msg').subscribe((res: string) => {
      this.CC_Msg = res;
    });

    translate.get('CC_Number').subscribe((res: string) => {
      this.CC_Number = res;
    });

    translate.get('CC_Name').subscribe((res: string) => {
      this.CC_Name = res;
    });
  }

  ngOnInit() {
    if (this.dialog_data.acct_name != undefined) {
      this.title = this.Acct_Statement;
      this.type = 'acct';

      this.model['acct_number'] = this.dialog_data.acct_number;
      this.from_date = this.dialog_data.from_date;
      this.to_date = this.dialog_data.to_date;
      this.acct_name = this.dialog_data.acct_name;

      this.search();
    }
    else {
      this.type = 'report';
      this.title = this.Acct_Statements;
    }
  }

  changeRepType() {
    if (this.model['rep_type'] == 'cost_center')
      this.cost_cneter_name = 'مركز التكلفة (الرئيسي - Main)'; 
  }

  onChangeSearch = function (search_result: object) {
    this.model['acct_number'] = search_result['no'];
  }

  onChangeCcSearch = function (search_result: object) {
    console.log(search_result['no']);
    if (search_result['no'] != '')
      this.model['cost_center'] = search_result['no'];
    else {
      this.model['cost_center'] = '0';
      this.cost_cneter_name = 'مركز التكلفة (الرئيسي - Main)'; 
      (document.getElementById('search_value_1') as HTMLInputElement).value = 'مركز التكلفة (الرئيسي - Main)';
    }
      
    console.log(this.model['cost_center']);
  }

  search() {
    if (this.type == 'report' && (this.model['from_date'] == undefined || this.model['from_date'].toString() == '')) {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.type == 'report' && (this.model['to_date'] == undefined || this.model['to_date'].toString() == '')) {
      alert(this.To_Date_Msg);
      return;
    }

    if (this.type == 'report' && this.model['rep_type'] == 'account' && this.model['acct_number'] == '') {
      alert(this.Acct_Msg);
      return;
    }

    if (this.type == 'report' && this.model['rep_type'] == 'cost_center' && this.model['cost_center'] == '') {
      alert(this.CC_Msg);
      return;
    }
    
    this.dp = [];
    let today = new Date();
    this.date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate() + " "
      + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

    if (this.type == 'report') {

      this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + ' 00:00:00';
      this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + ' 23:59:59';
        
      if (this.model['rep_type'] == 'account')
        this.acct_name = (document.getElementById('search_value_0') as HTMLInputElement).value;
      else {
        if (this.model['cost_center'] != '0')
          this.cost_cneter_name = (document.getElementById('search_value_1') as HTMLInputElement).value;
      }
    }

    let obj = { cmd: 'getAcctRep', from_date: this.from_date, 
      to_date: this.to_date };

    if (this.model['rep_type'] == 'account')
      obj['acct_number'] = this.model['acct_number'];
    else 
      obj['cost_center'] = this.model['cost_center'];

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data.status['msg']);
        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'][0]['rep_list'];
          this.total_credit = data.status['msg'][0]['total_credit'];
          this.total_debit = data.status['msg'][0]['total_debit'];
        }
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }


  print() {

    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="50%">' + this.Statement_Date + this.date + '</td><td width="50%"></td></tr>';
    
    if (this.model['rep_type'] == 'account') {
      html_data += '<tr><td width="50%"> ' + this.Acct_Name + ': ' + this.acct_name + '</td><td width="50%"> ' + 
        this.Acct_No + ': ' + this.model['acct_number'] + '</td></tr>';
    }
    else {
      html_data += '<tr><td width="50%"> ' + this.CC_Name + ': ' + this.cost_cneter_name + '</td><td width="50%"> ' + 
        this.CC_Number + ': ' + this.model['cost_center'] + '</td></tr>';
    }
    
    html_data += '<tr><td width="50%"> ' + this.From_Date + ': ' + this.from_date + '</td><td width="50%"> ' + 
      this.To_Date + ': ' + this.to_date + '</td></tr>';
    html_data += '<tr><td width="50%"> ' + this.Debit_Total + ': ' + this.total_debit + '</td><td width="50%"> ' + 
      this.Credit_Total + ': ' + this.total_credit + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('rep_acct2') as HTMLTableElement);
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title + '_' + this.model['acct_number'] + 
      '_' + this.acct_name);
  }

}
